export const globalBreakpoints = {
	mobile: 480,
	phablet: 768,
	tablet: 942,
	desktop: 1150,
	widescreen: 1600,
};
